import { Claim } from '../../../hooks/queries/useGetAccountInformation';
import { ClaimTypes } from '../enums/ClaimTypes';

const hasVerifiedClaim = (claims: Claim[], claimType: ClaimTypes): boolean => {
  return claims.some(({ taken, type }) => Boolean(taken) && type === claimType);
};

const hasVerifiedPhone = (claims: Claim[]): boolean => {
  return hasVerifiedClaim(claims, ClaimTypes.CELLPHONE);
};

const hasVerifiedEmail = (claims: Claim[]): boolean => {
  return hasVerifiedClaim(claims, ClaimTypes.EMAIL);
};

export { hasVerifiedPhone, hasVerifiedEmail };
